import { render } from "./Passes.vue?vue&type=template&id=18de1135&scoped=true"
import script from "./Passes.vue?vue&type=script&lang=js"
export * from "./Passes.vue?vue&type=script&lang=js"

import "./Passes.vue?vue&type=style&index=0&id=18de1135&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-sigur-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18de1135"],['__file',"src/assets/js/components/Passes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18de1135"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18de1135', __exports__)) {
    api.reload('18de1135', __exports__)
  }
  
  module.hot.accept("./Passes.vue?vue&type=template&id=18de1135&scoped=true", () => {
    api.rerender('18de1135', render)
  })

}


export default __exports__